/**
 * PATH: packages/email-hub/src/feature/provider-writeback/api.ts
 * FILE_ID: EMAILHUB-PROVIDER-WRITEBACK-API-001
 * PURPOSE: Typed process/restore/retry calls for provider receipts.
 */

import { emailApi } from '../lib/api'
import type { ProviderWritebackStateV1 } from '../lib/writebackContract'

export function requestProviderProcess(emailId: string) {
  return emailApi<ProviderWritebackStateV1>('/api/kanban/provider-writebacks/process/', {
    method: 'POST',
    body: JSON.stringify({ email_id: emailId }),
  })
}

export function requestProviderRestore(emailId: string) {
  return emailApi<ProviderWritebackStateV1>('/api/kanban/provider-writebacks/restore/', {
    method: 'POST',
    body: JSON.stringify({ email_id: emailId }),
  })
}

export function retryProviderWriteback(operationId: string) {
  return emailApi<ProviderWritebackStateV1>(
    `/api/kanban/provider-writebacks/${operationId}/retry/`,
    { method: 'POST' },
  )
}
